<template>
  <div class="profile-card">
    <div
      class="profile-owl-carousel__img show profile-card__image"
      v-bind:style="{ 'background-image': 'url(' + url + ')'}"
    >
      <div class="profile-card__bottom profile-card__bottom--dark-large">

      </div>
      <div class="rightbottom__corner--bottom-space">
        <div class="profile-card__card-symbol">
          <p>{{ profile.age }}</p>
          <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
          <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
        </div>
      </div>
      <div class="lefttop__corner--top-space">
        <div class="profile-card__card-symbol">
          <div class="profile-card__card-symbol">
            <p>{{ profile.age }}</p>
            <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
            <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
            <HeartWithTooltip variant="secondary" v-if="profile.has_heart"/>
          </div>
        </div>
      </div>


      <div class="leftbottom__corner--bottom-space">
        <div class="profile-card__card-data" v-show="showProfileDetails">
          <div class="profile-card__data-box">
            <h6>
              <button class="button button__link button__link--white profile-card__button-title" v-on:click="showProfile()">{{ profile.name }}</button>
              <span v-if="profile.is_online" class="dot-online"></span>
            </h6>
            <i @click="showProfile()" class="icon-info-circled-alt icon-info-circled-alt--small"></i>
          </div>
          <p>{{ profile.regular_address }}</p>
          <p>
            <i class="demo-icon icon-pin"></i>
            {{ profile.location.distance }}km
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeartWithTooltip from '../Profile/HeartWithTooltip.vue';

export default {
  name: 'ProfileCard',
  props: {
    profile: Object,
    src: String,
    showProfileDetails: Boolean,
  },
  components: {
    HeartWithTooltip
  },
  data() {
    return {};
  },
  methods: {
    showProfile() {
      this.$store.dispatch('matchGame/showButtons', false);
      this.$store.dispatch('matchGame/showProfileDetails', true);
      setTimeout(() => {
        window.scrollBy({ top: 150, behavior: 'smooth' });
      }, 200);

    },

  },
  computed: {
    url: function () {
      return this.src || this.profile.avatar_url;
    }
  },
  mounted() {
  }
};
</script>


